import { render, staticRenderFns } from "./orderReportDO.vue?vue&type=template&id=25004fb5&scoped=true&"
import script from "./orderReportDO.vue?vue&type=script&lang=js&"
export * from "./orderReportDO.vue?vue&type=script&lang=js&"
import style0 from "./orderReportDO.vue?vue&type=style&index=0&id=25004fb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25004fb5",
  null
  
)

export default component.exports